export default "__VITE_ASSET__90ed20a5__"